import { useEffect, useState } from 'react'

import { api } from '../api/client'
import { useAuth } from '../auth/AuthContext'

/**
 * Se Eagle (il monitoraggio, ADR-0022) è attivo per il tenant corrente.
 *
 * Eagle è **nascosto** a chi non ce l'ha: menu, pagina e sezione nel CI
 * compaiono solo quando questo dice `true`. Finché la risposta non arriva vale
 * `false`, così non si vede mai una voce che poi sparisce. La risposta si tiene
 * per tenant: una licenza non cambia mentre si naviga, e cambiando tenant la
 * domanda si rifà.
 */
export interface StatoEagle {
  /** Eagle è attivo per il tenant. */
  attivo: boolean
  /** Eagle è **da solo** (piano standalone): niente CENSO completo. */
  standalone: boolean
  /** The answer arrived (until then `attivo` is false by default). */
  pronto?: boolean
}

const SPENTO: StatoEagle = { attivo: false, standalone: false }
const memoria = new Map<string, Promise<StatoEagle>>()

function chiedi(tenant: string): Promise<StatoEagle> {
  let p = memoria.get(tenant)
  if (!p) {
    p = api
      .eagleStatus()
      .then((r) => ({ attivo: Boolean(r.licensed), standalone: Boolean(r.standalone), pronto: true }))
      .catch(() => {
        // Un errore di rete non deve «spegnere» Eagle per sempre.
        memoria.delete(tenant)
        return { ...SPENTO, pronto: true }
      })
    memoria.set(tenant, p)
  }
  return p
}

export function useStatoEagle(): StatoEagle {
  const { principal } = useAuth()
  const tenant = principal?.tenant_id ?? ''
  const [stato, setStato] = useState<StatoEagle>(SPENTO)
  useEffect(() => {
    if (!tenant) {
      setStato(SPENTO)
      return
    }
    let vivo = true
    chiedi(tenant).then((v) => {
      if (vivo) setStato(v)
    })
    return () => {
      vivo = false
    }
  }, [tenant])
  return stato
}

export function useEagle(): boolean {
  return useStatoEagle().attivo
}
